<template>
    <div>
        <div class="container-fluid mt-3">
            <b-card no-body>
                <b-card-header>
                    <div class="align-items-center row">
                        <div class="col d-flex flex-column align-items-star">
                            <h3 class="card-title mb-0">Depo İşlemleri</h3>
                            <div class="d-flex mt-2">
                                <div class="text-sm " style="width:200px;">
                                    <b-form-group class="mb-0">
                                        <b-form-select v-model="company" :options="usersAll" />
                                    </b-form-group>
                                </div>
                                <div class="text-sm ml-4" style="width:200px;">
                                    <b-form-group class="mb-0">
                                        <b-form-select v-model="filterType" :options="[
                                            { text: 'Tüm Zamanlar', value: '' },
                                            { text: 'Bugün', value: 'daily' },
                                            { text: 'Bu hafta', value: 'weekly' },
                                            { text: 'Bu ay', value: 'monthly' },
                                            { text: 'Tarih seç', value: 'other' },
                                        ]" />
                                    </b-form-group>
                                </div>
                                <template v-if="filterType === 'other'">
                                    <div class="text-sm ml-4" style="width:200px;">
                                        <b-form-group class="mb-0">
                                            <b-form-input type="date" v-model="startDate" />
                                        </b-form-group>
                                    </div>
                                    <div class="text-sm ml-4" style="width:200px;">
                                        <b-form-group class="mb-0">
                                            <b-form-input type="date" v-model="endDate" />
                                        </b-form-group>
                                    </div>
                                </template>
                                <div class="text-sm ml-4" style="width:200px;">
                                    <b-button variant="primary" @click="$refs.table.refresh()">{{ $t('Güncelle')
                                    }}</b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 text-right mt-3">
                        <b-button @click="
                            service = { tax: 0, used_time: 0 };
                        $refs.modal.show();
                        " class="btn-sm" variant="primary">+ Yeni İşlem Ekle
                        </b-button>
                    </div>
                    <b-modal ref="modal" title="Yeni İşlem" @hide="resetModal">
                        <b-col xs="12" md="12" class="px-0">
                            <b-form-group label="Ürün Gönderilecek Bayi">
                                <b-form-select v-model="newReport.company_id" :options="users" />
                            </b-form-group>
                        </b-col>
                        <b-row>
                            <b-col>
                                <b-form-group label="Kategori">
                                    <b-form-select v-model="newReport.category">
                                        <option value="Tavuk">Tavuk</option>
                                        <option value="Kuyruk Yağı">Kuyruk Yağı</option>
                                        <option value="Tereyağı">Tereyağı</option>
                                        <option value="Salça">Salça</option>
                                        <option value="Süper Acı">Süper Acı</option>
                                        <option value="Sumak">Sumak</option>
                                        <option value="Tatlı Toz">Tatlı Toz</option>
                                        <option value="Kekik">Kekik</option>
                                        <option value="Nane">Nane</option>
                                        <option value="Elbise(Personel)">Elbise(Personel)</option>
                                        <option value="Kağıt">Kağıt</option>
                                        <option value="Poşet">Poşet</option>
                                        <option value="Diğer">Diğer</option>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="newReport.category === 'Diğer'">
                            <b-col>
                                <b-form-group label="Kategori Adı Giriniz">
                                    <b-form-input required v-model="newReport.category" type="text"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Miktar (Ör. 10 Adet, 5kg)">
                                    <b-form-input required v-model="newReport.amount" type="text"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="Tarih">
                                    <b-form-input required v-model="newReport.date"
                                        type="datetime-local"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="Fiyat">
                                    <b-form-input required v-model="newReport.price" type="number"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <template v-slot:modal-footer>
                            <b-button variant="primary" @click="createStorageSubmit">{{ $t('Kaydet') }}
                            </b-button>
                        </template>
                    </b-modal>
                </b-card-header>
                <div class="table-container">
                    <b-table ref="table" class="align-items-center" thead-class="thead-light" :fields="getFields"
                        :items="items" show-empty>

                        <template v-slot:empty>
                            <div class="text-center">
                                {{ $t('Henüz hiçbir kayıt bulunmamakta.') }}!
                            </div>
                        </template>
                        <template v-slot:cell(sira)="data">
                            <div class="text-center">
                                {{ processes - data.index }}
                            </div>
                        </template>
                        <template v-slot:cell(price)="data">
                            <div class="text-center">
                                {{ formatCurrency(data.item.price) }}
                            </div>
                        </template>
                        <template v-slot:cell(date)="data">
                            <div class="text-center">
                                {{ moment(data.item.date).format('HH:mm DD-MM-YYYY') }}
                            </div>
                        </template>
                        <template v-slot:cell(created_at)="data">
                            <div class="text-center">
                                {{ moment(data.item.created_at).format('HH:mm DD-MM-YYYY') }}
                            </div>
                        </template>

                        <template v-slot:table-busy>
                            <div style="width: 100%; text-align:center;">
                                <b-spinner label="Spinning"></b-spinner>
                            </div>
                        </template>

                        <template v-slot:cell(title)="data">
                            <b-badge variant="success" v-if="data.item.type === 'income'">{{ $t('GELİR') }}</b-badge>
                            <b-badge variant="danger" v-else-if="data.item.type === 'expense'">{{ $t('GİDER')
                            }}</b-badge>
                        </template>

                        <template v-slot:cell(payment_type)="data">
                            <div v-if="data.item.payment_type === 'cash'">Nakit</div>
                            <div v-else-if="data.item.payment_type === 'card'">Kart</div>
                        </template>

                        <template v-slot:cell(actions)="data">
                            <b-button variant="danger" size="sm" v-if="getType != 'all'"
                                @click="deleteStorageAction(data.item.id)">Sil</b-button>
                        </template>

                    </b-table>

                    <div class="w-100 d-flex align-items-center justify-content-center mt-2 mb-3"
                        v-if="pagination.totalRows > 9">
                        <b-pagination @change="changepagination" v-model="pagination.currentPage"
                            :total-rows="pagination.totalRows" :per-page="pagination.perPage" />
                    </div>
                </div>
                <div class="w-full text-right p-3" v-if="getType != 'all'">
                    <b-button variant="primary" @click="printData">{{ $t('Gün Sonu Al') }}</b-button>
                    <!--          <b-button variant="info" @click="printDataExcel">{{ $t('Excel Rapor Al') }}</b-button> -->
                </div>
            </b-card>
        </div>
        <b-modal ref="accountingModal" :title="$t('İşlem Detayları')">
            <b-table :fields="[
                { key: 'sira', label: '' },
                { key: 'service.name', label: 'Ürün' },
                { key: 'price', label: 'Fiyat' }
            ]" :items="accounting_services" bordered>
                <template v-slot:cell(sira)="data">
                    <div class="text-center">
                        {{ data.index + 1 }}
                    </div>
                </template>
                <template v-slot:cell(price)="data">
                    <div class="">{{ formatCurrency(data.item.price) }} TL</div>
                </template>
            </b-table>
            <template v-slot:modal-footer>
                <b-button @click="$refs.accountingModal.hide()" variant="primary">{{ $t('Kapat') }}</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
    computed: {
        ...mapGetters(['companies']),

        getFields() {
            let arr = [
                { key: 'category', label: 'Kategori' },
                { key: 'amount', label: 'Miktar' },
                { key: 'price', label: 'Fiyat' },
                { key: 'created_at', label: 'Oluşturulma Tarihi' },
                { key: 'date', label: 'Gönderim Tarihi' },
                { key: 'user.name', label: 'Bayi' },
            ];
            arr.push({ key: 'actions', label: '', tdClass: 'text-right' })
            return arr
        },
        getType() {
            return this.$route.params.type
        }
    },
    data() {
        return {
            company: null,
            // maxDate:moment().subtract(1, 'days').format('YYYY-MM-DD'),
            maxDate: moment().format('YYYY-MM-DD'),
            incometypes: [],
            inSafeMoney: null,
            accounting: {},
            income: '0',
            expense: '0',
            processes: '0',
            filterType: 'daily',
            startDate: '',
            endDate: '',
            pagination: {
                currentPage: 1,
                totalRows: 1,
                perPage: 10,
            },
            dailyCash: 0,
            records: [],
            users: [],
            usersAll: [],
            newReport: {
                company: null,
                category: '',
                amount: '',
                price: '',
                date: '',
            },
            submitType: 'create',
            accounting_services: [],
            // filterDay:moment().subtract(1, 'days').format('YYYY-MM-DD')
            filterDay: moment().format('YYYY-MM-DD')
        }
    },
    methods: {
        ...mapActions(['getStorage', 'deleteAccounting', 'printExcel', 'getAccountingServices', 'allUsers', 'createStorage', 'deleteStorage']),
        moment,
        formatCurrency(value) {
            return new Intl.NumberFormat('tr-TR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        },
        deleteStorageAction(id) {
            this.$swal({
                icon: 'warning',
                title: 'Dikkat',
                text: 'İşlem kalıcı olarak silinecektir, emin misiniz?',
            }).then(ok => {
                if (ok.value) {
                    this.deleteStorage(id).then(res => {
                        this.success(res.data.message);
                        this.refreshTable();
                    }).catch(error => {
                        this.error(error.response.data.message);
                    });
                }
            });
        },
        refreshTable() {
            setTimeout(() => {
                this.$refs.table.refresh();
            }, 200);
        },
        getUsers() {
            this.allUsers().then(data => data.data).then(response => {
                this.users = [
                    ...response.users.map(user => ({
                        text: user.name,
                        value: user.id
                    }))
                ];
            })
        },
        getUsersAll() {
            this.allUsers().then(data => data.data).then(response => {
                this.usersAll = [
                    { text: 'Tümü', value: null },
                    ...response.users.map(user => ({
                        text: user.name,
                        value: user.id
                    }))
                ];
            })
        },
        changepagination(e) {
            this.$refs.table.refresh();
        },
        items() {
            const parameters = this.parameters();
            return this.getStorage(parameters).then(data => data.data).then(response => {
                console.log(response);
                const records = response.storage;
                this.records = records;
                this.pagination.totalRows = response.total;

                return records;
            }).catch(error => {
                this.error(error.response.data.message);
            })
        },
        resetAndHideModal() {
            this.resetModal();
            this.hideModal();
        },
        openModal() {
            this.$refs.modal.show();
        },
        hideModal() {
            this.$refs.modal.hide();
        },
        resetModal() {

            this.submitType = 'create';
            this.newReport = {
                company_id: null,
                category: '',
                amount: '',
                price: '',
                date: '',
            };
        },
        createStorageSubmit() {

            this.createStorage(this.newReport)
                .then((response) => {
                    this.success(response.data.message);
                    /*   this.hideModal();
                      this.refreshTable(); */
                })
                .catch((error) => {
                    this.format(error.response.data.errors).forEach((item) => {
                        this.error(item);
                    });
                });
        },
        parameters() {
            const params = {};
            params.type = this.filterType;
            params.company = this.company
            if (this.company != null) {
                params.company = this.company
            }

            if (params.type === 'other') {
                params.start_date = this.startDate;
                params.end_date = this.endDate;
            }

            params.page = this.pagination.currentPage;
            params.per_page = this.pagination.perPage;

            return params;
        }
    },
    async mounted() {
        await this.getUsers();
        await this.getUsersAll();
    }
}
</script>

<style>
.table-container {
    overflow-x: auto;
    /* Taşma durumunda yatay kaydırma çubuğu ekler */
    max-width: 100%;
    /* Kapsayıcının maksimum genişliğini ayarlayın */
}

td div {
    text-align: center !important;
}

td {
    text-align: center !important;
}

tr {
    text-align: center !important;
}
</style>